/**
 * @file Tiny HUD button: small mono/uppercase pill, `active` state for
 * segmented controls (speed/preset/backend pickers). `onMouseDown` calls
 * `preventDefault()` so clicking it never steals keyboard focus from the
 * canvas (WASD keeps working) — see the project-wide HUD focus rule.
 */
export default function Button({ active = false, className = '', children, onClick, ...rest }) {
  const tone = active
    ? 'border-gold/70 bg-gold/15 text-gold'
    : 'border-transparent text-hud-dim hover:border-hairline hover:text-hud';

  return (
    <button
      type="button"
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      className={`select-none rounded-[3px] px-2.5 py-1 font-hud text-[11px] font-bold uppercase tracking-[0.16em] transition ${tone} border ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
}
